// File: Pages/Reports/components/ReportTypeSelector.jsx

import React from 'react'
import PropTypes from 'prop-types'
import { REPORT_TYPE_OPTIONS } from '../utils/reportTypes'
import { CustomSelect } from '../../../Pages/Teases/CustomSelect'
import styles from '../index.module.css'

/**
 * Component for selecting the type of report
 * Can use either default report types or dynamically loaded ones
 */
const ReportTypeSelector = ({ selectedType, onTypeChange, reportTypeOptions }) => {
  // Use provided report type options or fall back to defaults
  const options = reportTypeOptions || REPORT_TYPE_OPTIONS
  
  const handleTypeSelect = (option) => {
    if (option !== selectedType) {
      onTypeChange(option)
    }
  }

  return (
    <div className={styles.formSection}>
      <h2 className={styles.sectionTitle}>What type of report are you submitting?</h2>
      <p className={styles.sectionSubtitle}>
        Please select the category that best describes your issue
      </p>
      
      <div className={styles.formRow}>
        <CustomSelect
          options={options}
          placeholder="Select report type"
          defaultOption={selectedType}
          onOptionSelect={handleTypeSelect}
          label="Report Type"
          isRequired={true}
        />
      </div>
    </div>
  )
}

ReportTypeSelector.propTypes = {
  selectedType: PropTypes.string,
  onTypeChange: PropTypes.func.isRequired,
  reportTypeOptions: PropTypes.arrayOf(PropTypes.string)
}

export default ReportTypeSelector